import {FormField, hasError, IFieldProps, onChangeField} from "~/components/Form";
import {Intent} from "~/lib/intent";
import React from "react";
import {ISelectProps, SelectInput} from "~/components/Controls/Select";
import {ID} from "~/lib/model";
import {sortByString} from "~/lib/sort";
import {TableSortDirection} from "~/components/Table";
import { useAccountManagersQuery } from "~/modules/Dictionary/queries";

type IAccountManagerProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectAccountManager = ({
                                         disabled,
                                         ...props
                                     }: IAccountManagerProps) => {
    const { data: resource = [], isPending } = useAccountManagersQuery();
    return <SelectInput {...props} disabled={disabled || isPending}
                        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
                        items={sortByString(resource.map(manager => ({
                            label: manager.name,
                            value: manager.id
                        })), 'label', TableSortDirection.ASC)}/>;
};

export const SelectAccountManagerField = (props: IFieldProps<IAccountManagerProps>) => <FormField {...props}>
    <SelectAccountManager {...props.options}
                          intent={hasError(props) && Intent.DANGER}
                          value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
